
import Component from "vue-class-component";
import {RefWithName} from "@/utils/Utils";
import {Prop, Provide, Vue} from "vue-property-decorator";
import SearchInput from "./SearchInput.vue";
import {CourseRef} from "@/modules/federation/services/CourseService";

@Component({
  components: {SearchInput}
})
export default class CourseSearchInput extends Vue {
  @Prop() value?: RefWithName<CourseRef>
  @Provide() query: string = "";
  @Prop() inputClass?: string;
  @Prop() size?: string;
  @Prop() placeholder?: string;
  @Prop() federationRef!: string
  @Prop() disabled?: boolean

  get inputValue(): any {
    return this.value;
  }

  get baseUri() {
    return `/course/${this.getFederationRef}/search`
  }

  get getFederationRef() {
    return this.federationRef
  }

  set inputValue(value: any) {
    this.$emit('input', value);
  }
}
